import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import ListItem from '@material-ui/core/ListItem';
import Request from '~/providers/Request';
import isBlank from '~/utils/isBlank';
import useStyles from './styles';

function TermsList() {
  const [urlPrivacy, setUrlPrivacy] = useState('');
  const [urlTerms, setUrlTerms] = useState('');
  const [urlCookies, setUrlCookies] = useState('');
  const { t } = useTranslation();
  const classes = useStyles();

  useEffect(()=> { searchEnvs(); }, []);

  const searchEnvs = async () => {
    try {
      let { data } = await Request.get('/public/env/PRIVACY_POLICY', null, { normalizeJSON: false });
      if(!isBlank(data?.url)) setUrlPrivacy(data.url);

      data = (await Request.get('/public/env/TERMS_OF_USE', null, { normalizeJSON: false })).data;
      if(!isBlank(data?.url)) setUrlTerms(data.url);

      data = (await Request.get('/public/env/TERMS_OF_COOKIES', null, { normalizeJSON: false })).data;
      if(!isBlank(data?.url)) setUrlCookies(data.url);

    } catch(e) { console.log('error', e); }
  };

  return (
    <ListItem
      classes={{
        root: classes.root,
      }}
    >
      <div style={{ display: 'flex', flexDirection: 'column'}}>
        <a rel="noopener noreferrer" style={{
          fontSize: 10,
          fontWeight: 600,
          color: '#FFFFFF',
          paddingTop: 3,
          paddingBottom: 3,
          textDecorationLine: 'none'
        }} target='_blank' href={urlTerms}>
          {t('terms_of_use').toUpperCase()}
        </a>
        <a rel="noopener noreferrer" style={{
          fontSize: 10,
          fontWeight: 600,
          color: '#FFFFFF',
          paddingTop: 3,
          paddingBottom: 3,
          textDecorationLine: 'none'
        }} target='_blank' href={urlCookies}>
          {t('cookies_policy').toUpperCase()}
        </a>
        <a rel="noopener noreferrer" style={{
          fontSize: 10,
          fontWeight: 600,
          color: '#FFFFFF',
          paddingTop: 3,
          paddingBottom: 3,
          textDecorationLine: 'none'
        }} target='_blank' href={urlPrivacy}>
          {t('privacy_policy').toUpperCase()}
        </a>

      </div>
    </ListItem>
  );
}

export default React.memo(TermsList);
